import { QuotaCriteria, QuotaRangeSet } from '../models/survey-quota.model';

export class SurveyQuotaCriterion {
  constructor(private readonly _criterion: QuotaCriteria) {}

  public qualificationCode(): number {
    return this._criterion.qualificationCode;
  }

  public isRange(): boolean {
    return !!this._criterion.rangeSets?.length;
  }

  public range(): QuotaRangeSet[] {
    return this._criterion.rangeSets || [];
  }

  public conditions(): string[] {
    return this._criterion.conditionCodes || [];
  }

  public conditionNames(): string[] {
    return this._criterion.conditionNames || [];
  }

  public values(): QuotaRangeSet[] | string[] {
    return this.isRange() ? this.range() : this.conditions();
  }
}
